import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/frontend/src/components/loading/Loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/frontend/src/components/loading/LoadingRefresh.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/frontend/src/components/loading/SoulEqualizerLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrderFormProvider"] */ "/app/frontend/src/components/orderdraft/OrderFormContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.bun/@mui+material@9.0.0+6ffb97a34087bd26/node_modules/@mui/material/Box/Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.bun/@mui+material@9.0.0+6ffb97a34087bd26/node_modules/@mui/material/CircularProgress/CircularProgress.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.bun/next@16.2.4+408004b0c890ffdc/node_modules/next/dist/client/script.js");
